import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect, withRouter } from 'react-router-dom';
import fire from './config/fire';

const Restricted = ({
  component: Component,
  isAuthenticated,
  emailVerified,
  requireVerifiedEmail,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      if (isAuthenticated !== true) {
        return (
          <Redirect
            to={{
              pathname: '/signin',
              search: `redirect=${encodeURIComponent(
                window.location.pathname + window.location.search
              )}`,
            }}
          />
        );
      }
      if (requireVerifiedEmail && emailVerified === false) {
        return (
          <Redirect
            to={{
              pathname: '/verify-email',
              search: `redirect=${encodeURIComponent(
                window.location.pathname + window.location.search
              )}`,
            }}
          />
        );
      }
      return <Component {...props} />;
    }}
  />
);

function mapStateToProps(state) {
  const firebaseUser = fire.auth().currentUser;
  return {
    isAuthenticated:
      (!!firebaseUser && !firebaseUser.isAnonymous) ||
      (!!localStorage.getItem('br-storage-key') &&
        !localStorage.getItem('br-is-anonymous')),
    emailVerified: firebaseUser ? firebaseUser.emailVerified : undefined,
    idToken: localStorage.getItem('br-storage-key'),
    location: state.location,
  };
}

export default withRouter(connect(mapStateToProps, null)(Restricted));
